// extracted by mini-css-extract-plugin
export default {"description":"Lt6EK","icon":"i_qXw","text":"xFMLz"};